import { createFeature, createReducer, on } from '@ngrx/store';
import { SettingsActions } from './settings.actions';
import { Language } from '../../../libs/system/model/language';

export interface SettingsState {
  theme: string;
  themes: string[];
  online: boolean;
  miniSideNav: boolean;
  language: Language;
  pageSize: number;
}

export const settingsInitialState: SettingsState = {
  theme: '',
  themes: null,
  online: false,
  miniSideNav: false,
  language: {
    dateFormat: 'l',
  },
  pageSize: null,
};

export const settingsFeature = createFeature({
  name: 'settings',
  reducer: createReducer(
    settingsInitialState,

    on(SettingsActions.loadTheme, (state, { themes }) => ({
      ...state,
      themes, // allowedThemes
    })),
    on(SettingsActions.applyTheme, (state, { theme }) => ({
      ...state,
      theme,
    })),
    on(SettingsActions.miniSideNavFlag, (state, { mini }) => ({
      ...state,
      miniSideNav: mini,
    })),
    on(SettingsActions.networkStatusFlag, (state, { online }) => ({
      ...state,
      online,
    })),
    on(SettingsActions.setLanguage, (state, { language }) => ({
      ...state,
      language,
    })),
    on(SettingsActions.setPageSize, (state, { pageSize }) => ({
      ...state,
      pageSize,
    })),
  ),
});
